import { useRef } from "react";
import { Button, Row, Col } from "react-bootstrap";
import SignatureCanvas from "react-signature-canvas";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";

const SignaturePad = ({
  signature,
  setSignature,
  admissionID,
  error,
  setFormData
  // center_uuid,
}) => {
  // console.log(signature);
  const API_URL = process.env.REACT_APP_API_URL;
  // const PORTAL_URL = process.env.REACT_APP_PORTAL_URL;

  const signaturePadRef = useRef();
  // const [isSigned, setIsSigned] = useState(false);

  // User draws signature
  const handleSignature = () => {
    // setIsSigned(true);
    const base64 = signaturePadRef.current.getCanvas().toDataURL("image/png");
    setSignature(base64);
  };

  // function dataURLtoFile(dataurl, filename) {
  //   var arr = dataurl.split(","),
  //     mime = arr[0].match(/:(.*?);/)[1],
  //     bstr = atob(arr[1]),
  //     n = bstr.length,
  //     u8arr = new Uint8Array(n);
  //   while (n--) {
  //     u8arr[n] = bstr.charCodeAt(n);
  //   }
  //   return new File([u8arr], filename, { type: mime });
  // }

  // Done: Upload signature
  // const handleDone = async () => {
  //   const base64 = signaturePadRef.current.getCanvas().toDataURL("image/png");
  //   // setFormData((prev) => ({
  //   //   ...prev,
  //   //   signature: base64,
  //   // }));

  //   // Convert base64 to File
  //   const file = dataURLtoFile(base64, "signature.png");

  //   handleUpload(file);
  // };

  // Clear: Renew signature
  const handleClear = () => {
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
    }
    // setIsSigned(false);
    setSignature(null);
  };

  // Delete: Remove from DB
  const handleDelete = async () => {
    try {
      const fD = new FormData();
      fD.append("field_name", "signature");
      fD.append("table_name", "admission_extra_info");
      fD.append("admission_id", admissionID);
      const response = await fetch(`${API_URL}/delete-doc`, {
        method: "POST",
        body: fD,
      });
      if (response.ok) {
        setSignature(null);
        setFormData((prev) => ({
          ...prev,
          signature: null,
        }));
        toast.success(<FormattedMessage id="validation.file_deleted" />);
      }
    } catch (error) {
      // error handling
    }
  };

  // const handleUpload = async (file) => {
  //   try {
  //     const fD = new FormData();
  //     fD.append("file", file);
  //     fD.append("field_name", "signature");
  //     fD.append("admission_id", admissionID);
  //     const response = await fetch(`${API_URL}/upload-doc`, {
  //       method: "POST",
  //       body: fD,
  //     });
  //     if (response.ok) {
  //       const data = await response.json();
  //       const { data: resData } = data;

  //       console.log("data", resData["signature"]);
  //       file.preview = `${PORTAL_URL + center_uuid}/admissions_school/${
  //         resData["signature"]
  //       }`;
  //       setSignature(file);
  //       toast.success(<FormattedMessage id='validation.file_uploaded' />);
  //     } else {
  //       console.log("NOT OK");
  //     }
  //   } catch (error) {
  //     console.log("Error!");
  //     console.log(error);
  //   }
  // };
  // console.log(signature)
  return (
    <>
      <Row className="my-4">
        <Col md={12}>
          <FormattedMessage id="signature" />

          {/* Show preview and delete if uploaded */}
          {signature && typeof signature === "object" && signature.preview ? (
            <div className="my-2">
              <img
                src={signature.preview}
                alt="Signature Preview"
                style={{
                  border: "1px solid #ccc",
                  maxWidth: 400,
                  maxHeight: 150,
                }}
              />
              <div className="mt-2">
                <Button variant="danger" size="sm" onClick={handleDelete}>
                  Delete
                </Button>
              </div>
            </div>
          ) : (
            <div
            className="my-2"
              style={{
                border: "1px solid #ccc",
                borderRadius: 8,
                width: 400,
                height: 150,
              }}
            >
              <SignatureCanvas
                ref={signaturePadRef}
                penColor="black"
                canvasProps={{
                  width: 400,
                  height: 150,
                  className: "sigCanvas",
                }}
                onEnd={handleSignature}
              />

              <div className="mt-2">
                {error && (
                  <small className="text-danger mt-1" style={{ fontSize: 12 }}>
                    <FormattedMessage id="error.signature" />
                  </small>
                )}
              </div>
              <div className="mt-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleClear}
                >
                  Clear
                </Button>
              </div>
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};

export default SignaturePad;
